import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext } from 'react';
import VideoStatistics from 'components/SecondaryView/_components/Statistics';

interface IChapterSummary {
  videoHashId: string;
  channelHashId: string;
  channelName: string;
}

export default function VideoStats({ videoHashId, channelHashId, channelName }: IChapterSummary) {
  const { hideModal } = useContext(ModalContext);

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:min-h-[200px]">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Statistics</span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={() => hideModal()}
          />
        </div>
        <div className="mt-5 px-7">
          <VideoStatistics channelId={channelHashId} videoHashId={videoHashId} channelName={channelName} />
        </div>
      </div>
    </div>
  );
}
